import { createSelector } from 'reselect'
import { has } from 'lodash'

export const getApp = (state) => state.app

export const getAppName = createSelector(
    getApp,
    app => app && app.name,
)

export const getCsrfToken = createSelector(
    getApp,
    app => app && app.security.csrfToken,
)

export const getLicenses = createSelector(
    getApp,
    app => app && app.licenses,
)

export const getVisualizerLicense = createSelector(
    getLicenses,
    licenses => licenses.visualizer,
)

export const getCollaborativeIndexationLicense = createSelector(
    getLicenses,
    licenses => licenses.collaborativeIndexation.condition
)

export const getVisualizerLicenseText = createSelector(
    getVisualizerLicense,
    license => license && license.text,
)

export const getTwitterId = createSelector(
    getApp,
    app => app && app.twitterId,
)

export const isLicenseEnabled = createSelector(
    getVisualizerLicense,
    license => license !== null,
)

export const getUserProfile = createSelector(
    getApp,
    app => app && app.userProfile,
)

export const isUserLoggedIn = createSelector(
    getUserProfile,
    userProfile => userProfile && userProfile.loggedIn,
)

export const isUserCollaborativeIndexerStatusActive = createSelector(
    getUserProfile,
    userProfile => userProfile && userProfile.isCollaborativeIndexerStatusActive
)

export const isBookmarkDisabled = createSelector(
    isUserLoggedIn,
    isUserLoggedIn => ! isUserLoggedIn,
)

export const getToolbarShareEmailBody = createSelector(
    getApp,
    app => {
        if(app && app.toolbar && app.toolbar.shareMail && app.toolbar.shareMail.body)
        {
            return app.toolbar.shareMail.body
        }

        return ''
    }
)

export const isSocialEnabled = createSelector(
    getApp,
    app => {
        if(app && app.toolbar && app.toolbar.isSocialEnabled)
        {
            return app.toolbar.isSocialEnabled
        }

        return ''
    }
)

export const isDownloadEnabled = createSelector(
    getApp,
    app => {
        if(app && app.toolbar && app.toolbar.isDownloadEnabled === false)
        {
            return false
        }

        return true
    }
)

export const getCaptcha = createSelector(
    getApp,
    app => app && app.security.captcha
)

export const getLocale = createSelector(
    getApp,
    app => app && app.locale,
)

export const isCollaborativeIndexationEnabled = createSelector(
    getApp,
    app => app.collaborativeIndexation.isEnabled
)

export const isCollaborativeIndexationAutoDisplayEnabled = createSelector(
    getApp,
    isCollaborativeIndexationEnabled,
    (app, isCollaborativeIndexationEnabled) => isCollaborativeIndexationEnabled && app.collaborativeIndexation.isAutoDisplayEnabled
)

export const getMatomoConfiguration = createSelector(
    getApp,
    app => {
        if(! has(app.analytics, 'matomo'))
        {
            return null
        }

        if(has(app.analytics.matomo, 'id') && has(app.analytics.matomo, 'url'))
        {
            return app.analytics.matomo
        }

        return null
    }
)

export const isMatomoEnabled = createSelector(
    getMatomoConfiguration,
    matomo => matomo !== null
)

export const getGoogleAnalyticsConfiguration = createSelector(
    getApp,
    app => {
        if(! has(app.analytics, 'googleAnalytics'))
        {
            return null
        }

        if(has(app.analytics.googleAnalytics, 'id'))
        {
            return app.analytics.googleAnalytics
        }

        return null
    }
)

export const isGoogleAnalyticsEnabled = createSelector(
    getGoogleAnalyticsConfiguration,
    googleAnalytics => googleAnalytics !== null
)
